<template>
  <div class="aCenter">
    <div class="left">
      <div id="checkleft"></div>
    </div>
    <div class="center">
      <div class="titleImage">近七日检测人次分布</div>
      <div id="checkcenter"></div>
    </div>
    <div class="right" id="checkrightCView">
      <div>
        <div class="rightTitle">近七日血压异常数据占比</div>
        <div class="percentView" style="position:relative;align:cneter;">
          <div class="pValueLabel">{{percent0}}</div>
          <div class="pUnitLabel">%</div>
          <AArcSvgPercentView v-bind:aId="svg0" v-bind:progress="percent_blood_pressure" style="position:absolute;"></AArcSvgPercentView>
        </div>
      </div>

      <div>
        <div class="rightTitle">近七日血糖异常数据占比</div>
        <div class="percentView">
          <div class="pValueLabel">{{percent1}}</div>
          <div class="pUnitLabel">%</div>
          <AArcSvgPercentView v-bind:aId="svg1" v-bind:progress="percent_blood_sugar" style="position:absolute;"></AArcSvgPercentView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from "echarts";
import RadialProgressBar from "vue-radial-progress";
import AArcSvgPercentView from "@/view/pages/bigScreem/AArcSvgPercentView";
import { type } from "os";
export default {
  name: "ABigScreemCenter",
  props: [
    "barData",
    "line_data_date",
    "line_data_num",
    "percent_blood_pressure",
    "percent_blood_sugar"
  ],
  components: {
    RadialProgressBar,
    AArcSvgPercentView
  },
  data() {
    return {
      startColor1: "#feff90FF",
      stopColor1: "#feff9024",
      innerStrokeColor: "#002370a1",
      svg0:'svg0',
      svg1:'svg1',
    };
  },
  computed: {
    percent0: function() {
      var p = (parseFloat(this.percent_blood_pressure) * 100).toFixed(0);
      if (isNaN) {
        return parseInt(p);
      } else {
        return 0;
      }
    },
    percent1: function() {
      var p = (parseFloat(this.percent_blood_sugar) * 100).toFixed(0);
      if (isNaN) {
        return parseInt(p);
      } else {
        return 0;
      }
    }
  },
  watch: {
    barData: function(newValue, oldValue) {
      this.handleLeft();
    },
    line_data_num: function(newValue, oldValue) {
      this.handleCenter();
    }
  },
  mounted() {
    this.handleLeft();
    this.handleCenter();
  },
  methods: {
    handleLeft() {
      let myChart = Echarts.init(document.getElementById("checkleft"));
      const option = {
        title: {
          text: "近七日检测时间分布",
          padding: [20, 40],
          textStyle: {
            color: "#C7E8FF",
            fontSize: 16
          }
        },
        grid: {
          top: "80px",
          bottom: "20px"
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: this.barData.date,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5ABBFF"
            },
            // rotate: 40,
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["rgba(181, 193, 212, 0.2)"]
            }
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5ABBFF"
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#6EC6F0"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(181, 193, 212, 0.2)"]
            }
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            data: this.barData.num,
            type: "bar",
            barWidth: 15,
            itemStyle: {
              normal: {
                color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 0, color: "#000F9587" },
                  { offset: 1, color: "#FF0F9587" }
                ])
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      console.log("come on **********");
      console.log(myChart);
    },
    handleCenter() {
      let myChart = Echarts.init(document.getElementById("checkcenter"));
      const option = {
        title: {
          show: false,
          text: "近七日检测时间分布",
          padding: [20, 40],
          textStyle: {
            color: "#C7E8FF",
            fontSize: 16
          }
        },
        grid: {
          top: "25px",
          bottom: "20px"
        },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: this.line_data_date,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5ABBFF"
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["rgba(181, 193, 212, 0.2)"]
            }
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5ABBFF"
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#6EC6F0"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(181, 193, 212, 0.2)"]
            }
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            data: this.line_data_num,
            type: "line",
            smooth: false,
            itemStyle: {
              normal: {
                color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 0, color: "#000F9587" },
                  { offset: 1, color: "#FF0F9587" }
                ])
              }
            },
            areaStyle: {
              normal: {
                color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#0081B3FF" },
                  { offset: 1, color: "#003382FF" }
                ])
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      console.log("come on **********");
      console.log(myChart);
    }
  }
};
</script>

<style scoped>
.aCenter {
  height: 365px;
  display: flex;
}


.left{
  flex: 0.9
}

.center{
  flex: 1
}
.right{
  flex: 0.8
}

.aCenter > div {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}



#checkleft {
  flex: 1;
  width: 100%;
  height: 100%;
}
#checkcenter {
  flex: 1;
  width: 100%;
  /* height: 100%; */
}

.titleImage {
  height: 41px;
  line-height: 41px;
  width: 329px;
  text-align: center;
  color: #c7e8ffff;
  font-size: 16px;
  background-image: url("~@/assets/images/bigScreem/title_bg.png");
}

#checkrightCView {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#checkrightCView > div {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.right > div {
  height: 100%;
}

.rightTitle {
  color: #c7e8ffff;
  font-size: 16px;
  padding-top: 25px;
  padding-left: 50px;
}

.AArcSvgPercentView {
  flex: 1;
  height: 100%;
  width: 100%;
}

.percentView {
  flex: 1;
  display: flex;
  color: #c7e8ff;
  font-size: 44px;
  align-items: center;
  justify-content: center;
}


.pUnitLabel {
  font-size: 14px;
}
</style>
